import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Treeselect from '@riophae/vue-treeselect';
import Paginate from "vuejs-paginate";
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import PageTracker from '../../../common/PageTrackerHelper';
import tableTemplate from '../common/table-template';
import DatePicker from 'vue2-datepicker';
import moment from 'moment'
import {BasicSelect} from 'vue-search-select';
import { applySmartInputStyles, clearSmartInputStyles, createClearInputWatcher } from "../../../common/inputStyleHelper";

export default {
  name: 'MisrouteRequestMaker',
  components: {
    VueElementLoading,
    Treeselect,
    Paginate,
    BasicSelect,
    'load-table-template' : tableTemplate,
    'date-picker' : DatePicker,
  },
  mixins:[PageTracker],
  data: function() {
    return {
      MarkShipmentStatus : "XBU00260",
      // ddlMisrouteReason : [],
      ddlMisrouteReason1 : '',
      txtShipment : '',
      txtPincode : '',
      ddlHub : '',
      // ODAerror : '',
      // reasonObj : [],
      shipmentTypeObj : [],
      shipmentStatusObj : [],
      getHubObj : [],
      hubFlag : true,
      // DistanceKm : '',
      // DistanceFlag : false,
      // HubLabelFlag : false,
      hubDiv : true,
      hub:'',
      hubid:'',
      currentHubID : '',
      isHubLoading: false,
      isSubmitLoading: false,
      loader:'<div class="velmld-spinner"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="18px" viewBox="0 0 24 30" xml:space="preserve"><rect x="0" y="5.59869" width="4" height="19.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="10" y="9.59869" width="4" height="11.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="20" y="12.4013" width="4" height="6.19739" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate></rect></svg></div>',
      ReasonLoader : '',
      HubLoader: '',
      createdBy:'',
      ActiveTabIndex: 0,
      ActiveTabIndex1: 0,
      Shipmentloader: false,
      currentTab:'Request Misroute',
      currentTab1:'All Requests',
      isResetLoad : false,
      CurrentAddress: '',
      CurrentPincode: '',
      CurrentDestSVC: '',
      SearchShip : '',
      MisrouteType : '',
      MisrouteReason : '',
      SearchShip1 : '',
      MisrouteType1 : '',
      MisrouteReason1 : '',
      SearchShip2 : '',
      MisrouteType2 : '',
      MisrouteReason2 : '',
      SearchShip3 : '',
      MisrouteType3 : '',
      MisrouteReason3 : '',
      ShipmentDetails: [],
      showShipmentReqList: [],
      ShipmentCount: 0,
      fromdate: '',
      todate: '',
      AllReqColumns: [
        // {
        //   "label": 'ShippingID',
        //   "key": "shippingid"
        // },
        {
          "label": 'Shipment Type',
          "key": "shipmenttype"
        },
        {
          "label": 'Misroute Type',
          "key": "misroutetype"
        },
        {
          "label": 'Misroute Reason',
          "key": "misroutereason"
        },
        {
          "label": 'Current SVC',
          "key": "currenthub"
        },
        {
          "label": 'Suggested SVC',
          "key": "suggestedhub"
        },
        {
          "label": 'Misroute Count',
          "key": "misroutecount"
        },
        {
          "label": 'Rejection Count',
          "key": "rejectioncount"
        },
        {
          "label": 'Created Date',
          "key": "createddate"
        }
      ],
      PendingColumns: [
        // {
        //   "label": 'ShippingID',
        //   "key": "shippingid"
        // },
        {
          "label": 'Shipment Type',
          "key": "shipmenttype"
        },
        {
          "label": 'Misroute Type',
          "key": "misroutetype"
        },
        {
          "label": 'Misroute Reason',
          "key": "misroutereason"
        },
        {
          "label": 'Current SVC',
          "key": "currenthub"
        },
        {
          "label": 'Suggested SVC',
          "key": "suggestedhub"
        },
        {
          "label": 'Misroute Count',
          "key": "misroutecount"
        },
        {
          "label": 'Rejection Count',
          "key": "rejectioncount"
        },
        {
          "label": 'Created Date',
          "key": "createddate"
        }
      ],
      AcceptedColumns: [
        // {
        //   "label": 'ShippingID',
        //   "key": "shippingid"
        // },
        {
          "label": 'Shipment Type',
          "key": "shipmenttype"
        },
        {
          "label": 'Misroute Type',
          "key": "misroutetype"
        },
        {
          "label": 'Misroute Reason',
          "key": "misroutereason"
        },
        {
          "label": 'Misroute Count',
          "key": "misroutecount"
        },
        {
          "label": 'Updated Pincode',
          "key": "actualpincode"
        },
        {
          "label": 'Updated HubName',
          "key": "actualdestinationhub"
        },
        {
          "label": 'Accepted By',
          "key": "lastmodifiedby"
        },
        {
          "label": 'LastModified Date',
          "key": "lastmodifieddate"
        }
      ],
      RejectedColumns: [
        // {
        //   "label": 'ShippingID',
        //   "key": "shippingid"
        // },
        {
          "label": 'Shipment Type',
          "key": "shipmenttype"
        },
        {
          "label": 'Misroute Type',
          "key": "misroutetype"
        },
        {
          "label": 'Misroute Reason',
          "key": "misroutereason"
        },
        {
          "label": 'Misroute Count',
          "key": "misroutecount"
        },
        {
          "label": 'Rejection Count',
          "key": "rejectioncount"
        },
        {
          "label": 'Rejection Reason',
          "key": "statuscomment"
        },
        {
          "label": 'Rejected By',
          "key": "lastmodifiedby"
        },
        {
          "label": 'LastModified Date',
          "key": "lastmodifieddate"
        }
      ],
      AllReqPageNo: 1,
      PendingPageNo : 1,
      AcceptedPageNo : 1,
      RejectedPageNo : 1,
      DateFilterPageNo: 1,
      AllReqPagecount: 0,
      PendingPagecount: 0,
      AcceptedPagecount: 0,
      RejectedPagecount: 0,
      DateFilterPagecount: 0,
      PageLimit: 20,
      ShowAllReqModel: false,
      PendingReqModel: false,
      AcceptedReqModel: false,
      RejectedReqModel: false,
      withDrawReqModel: false,
      IsReqStatus: false,
      currentFromDate: '',
      currentFromDate1: '',
      currentFromDate2: '',
      currentFromDate3: '',
      currentToDate: '',
      currentToDate1: '',
      currentToDate2: '',
      currentToDate3: '',
      reasonObj1: '',
      awbArray: [],
      awbArray1: [],
      awbArray2: [],
      awbArray3: [],
      IsValidationError: false,
      validDateRangeFrom: null,
      selectedFromDate: null,
      unAssTabShipCount: 0,
      pendignShipCount: 0,
      acceptedShipCount: 0,
      rejectedShipCount: 0,
      rejectedByMdMCount: 0,
      rejectedBySVCCount: 0,
      allReqCount: 0,
      currentRejScreenTab: 'RejByMDM',
      rejectedBy: "",
      currentFiltersTab: 'clearFilters',
      ShipmentTypeList: [{value: 1,text: "Delivery"},{value: 2,text: "RVP"},{value: 3,text: "RTO/DTO"}],
      ShipmentTypeObj: {},
      MisroutetypeList: [{value: 1,text: "Inter City"},{value: 2,text: "Intra City"},],
      MisroutetypeObj: {},
      MisrouteReasonList: [],
      MisrouteReasonObj: {},
      ShipmentType : '',
      ShipmentType1: '',
      ShipmentType2: '',
      ShipmentType3: '',
      ReqShipmentType: '',
      ReqVendorName: '',
      ReqVendorAddr: '',
      isRTODTO: false,
      isRTODTOReason: false,
      ReqMisrouteReason: '',
      HubList: [],
      HubObj: {},
      RTOPincode: '',
      RDHubID: '',
      RejectionCount: 0,
      misrouteFlagDel: false,
      misrouteFlagRvp: false,
      misrouteRtoDtoFlag: false,
      isCorrectPinInput: false,
      geoPincodeList: [],
      isGeoPincodesAndHub: false,
      geoPincode: '',
      geoPincodeObj: {text: ""},
      pincodeDerivedFrom: '',
      misrouteCount: 0,
      MoreShipmentModel: false,
      moreShipmentsColumns:[
        {
          "label": 'Shipment Type',
          "key": "ShipmentType"
        },
        {
          "label": 'Vendor Name',
          "key": "RTOName",
        },
      ],
      sameVendorShipCount: 0,
      sameVendorShipList: [],
      // moreShipmentsList: false,
      moreShipLink: false,
      ReqMisrouteShipsArray: [],
      MultiShipmentloader: false,
      successErrorResModel: false,
      dismissCountDown: 0,
      dismissSecs: 20,
      requestsErrorMsg: [],
      reqErrorCount: "",
      reqSuccessCount: "",
      isGeoFlowEnabled: false,
      getShipDataLoader: false,
      userDataKey : '',
    }
  },
  updated() {
    if(this.ActiveTabIndex == 0){
      $('.requestTab ul li a:first').addClass('active');
    }
  },
  created: function() {
    this.getHubList();
  },
  watch: {
    txtShipment: createClearInputWatcher('txtShipment'),
  },
  async mounted() {
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    this.currentHubID = userdetail.hubdetails[0];
    this.createdBy = userdetail.username;
    let isMisrouteEnabled = await this.getMisrouteEnabledFlag(this.currentHubID);
    this.misrouteFlagDel = isMisrouteEnabled.flagDel;
    this.misrouteFlagRvp = isMisrouteEnabled.flagRvp;
    this.misrouteRtoDtoFlag = isMisrouteEnabled.flagRtoDto;
    this.isGeoFlowEnabled = isMisrouteEnabled.isGeoEnabledForUI;

    if(!this.misrouteFlagDel && !this.misrouteFlagRvp && !this.misrouteRtoDtoFlag) {
      this.$alertify.error('Your are not authorized user/hub for Misroute Maker-Checker module.!')
      this.$router.push('/MarkingMisrouteODA')
      return false;
    }
    console.log("isMisrouteEnabled",isMisrouteEnabled);

  },
  methods: {
    tabTitle(title, count) {
      return `${title} (${count})</span>`;
    },

    SwitchTabs(){
      if(this.ActiveTabIndex == 0){
        this.ActiveTabIndex1 = 0;
        this.IsReqStatus = false;
        this.clear();
      }
      if(this.ActiveTabIndex == 1){
        this.IsReqStatus = true;
        this.clearMisrouteForm();
        this.SwitchReqTabs();
        this.tabWiseShipmentsCount();
        this.getMisrouteReasonsByType(null);
        // this.reasonObj1 = this.ddlMisrouteReason;
      }
    },

    //function to switch request tabs...
    SwitchReqTabs(){
      if(this.ActiveTabIndex == 1 && this.ActiveTabIndex1 == 0){
        // this.getAllReqList();
        this.clear();
      }
      if(this.ActiveTabIndex == 1 && this.ActiveTabIndex1 == 1){
        // this.getPendingReqList();
        this.clear();
      }
      if(this.ActiveTabIndex == 1 && this.ActiveTabIndex1 == 2){
        // this.getAcceptedReqList();
        this.clear();
      }
      if(this.ActiveTabIndex == 1 && this.ActiveTabIndex1 == 3){
        // this.getRejectedReqList();
        this.clear();
      }
    },

    async GetCurrentRejectedTab(currentVal) {
      this.currentRejScreenTab = currentVal;
      if (currentVal == 'RejByMDM') {
        this.rejectedBy = "1";
      }
      else if (currentVal == 'RejBySVC') {
        this.rejectedBy = "0";
      }
      this.getRejectedReqList();
    },

    async getCurrentFilterTabs(currentVal){
      this.currentFiltersTab = currentVal;
    },

    selectShipmentType(obj) {
      this.ShipmentTypeObj = obj;
      if(this.ActiveTabIndex == 1 && this.ActiveTabIndex1 == 0){
        this.ShipmentType = obj.text
      }
      if(this.ActiveTabIndex == 1 && this.ActiveTabIndex1 == 1){
        this.ShipmentType1 = obj.text
      }
      if(this.ActiveTabIndex == 1 && this.ActiveTabIndex1 == 2){
        this.ShipmentType2 = obj.text
      }
      if(this.ActiveTabIndex == 1 && this.ActiveTabIndex1 == 3){
        this.ShipmentType3 = obj.text
      }
    },

    //Get misroute Type List
    selectMisrouteType(obj) {
      this.MisroutetypeObj = obj;
      if(this.ActiveTabIndex == 1 && this.ActiveTabIndex1 == 0){
        this.MisrouteType = obj.text
      }
      if(this.ActiveTabIndex == 1 && this.ActiveTabIndex1 == 1){
        this.MisrouteType1 = obj.text
      }
      if(this.ActiveTabIndex == 1 && this.ActiveTabIndex1 == 2){
        this.MisrouteType2 = obj.text
      }
      if(this.ActiveTabIndex == 1 && this.ActiveTabIndex1 == 3){
        this.MisrouteType3 = obj.text
      }
    },

    selectMisrouteReason(obj) {
      this.MisrouteReasonObj = obj;
      if(this.ActiveTabIndex == 0){
        this.ReqMisrouteReason = obj.text
        if(obj.value === 390){
          this.isRTODTOReason = true;
          this.RDHubID = '';
          this.ddlHub = '';
          this.HubObj = {};
          this.hub = '';
        }
        else{
          if(this.isRTODTO == true){
            this.txtPincode = null;
          }
          this.RDHubID = '';
          // this.ddlHub = '';
          // this.HubObj = {};
          this.isRTODTOReason = false;
        }
      }
      if(this.ActiveTabIndex == 1 && this.ActiveTabIndex1 == 0){
        this.MisrouteReason = obj.text
      }
      if(this.ActiveTabIndex == 1 && this.ActiveTabIndex1 == 1){
        this.MisrouteReason1 = obj.text
      }
      if(this.ActiveTabIndex == 1 && this.ActiveTabIndex1 == 2){
        this.MisrouteReason2 = obj.text
      }
      if(this.ActiveTabIndex == 1 && this.ActiveTabIndex1 == 3){
        this.MisrouteReason3 = obj.text
      }
    },

    async getMisrouteReasonsByType(isRtoDto){
      if(isRtoDto == false){
        this.MisrouteReasonList = await this.getMisrouteReasonForDelRVP();
      }
      else if(isRtoDto == true){
        this.MisrouteReasonList = await this.getMisrouteReasonForRTODTO();
      }
      else{
        let ReasonList1 = await this.getMisrouteReasonForDelRVP();
        let ReasonList2 = await this.getMisrouteReasonForRTODTO();
        let combinationArr = ReasonList1.concat(ReasonList2);
        let uniqueObject = {};
        for (let i in combinationArr) {
          // Extract the text
          let objText = combinationArr[i]['text'];
          // Use the text as the index
          uniqueObject[objText] = combinationArr[i];
        }
        let FinalReasonList = [];
        for (let i in uniqueObject) {
          FinalReasonList.push(uniqueObject[i]);
        }
        this.MisrouteReasonList = FinalReasonList;
      }
    },

    getMisrouteReasonForDelRVP(){
      return new Promise( (resolve, reject) => {
        let reasonList = [];
        axios.post(apiUrl.api_url + 'shipmentmisroute/reasondetailsbytype', {"ReasonType": "MarkMisroute"})
        .then((response) => {
          if(response.data.code===200){
            let resLength = response.data.data.length;
            for (let i = 0; i < resLength; i++) {
              reasonList.push({
                value: response.data.data[i].ReasonsID,
                text: `${response.data.data[i].Reason}`,
              });
            }
          }
          else {
            this.reasonList = [];
          }
          resolve(reasonList);
        })
        .catch((httpException) => {
          this.$alertify.error("Failed to load misroute reasons.!");
          console.error('exception is:::::::::', httpException)
        })
      })
    },

    getMisrouteReasonForRTODTO(){
      return new Promise( (resolve, reject) => {
        let reasonList = [];
        axios.post(apiUrl.api_url + 'shipmentmisroute/reasondetailsbytype', {"ReasonType": "MarkVendorMisroute"})
        .then((response) => {
          if(response.data.code===200){
            let resLength = response.data.data.length;
            for (let i = 0; i < resLength; i++) {
              reasonList.push({
                value: response.data.data[i].ReasonsID,
                text: `${response.data.data[i].Reason}`,
              });
            }
          }
          else {
            reasonList = [];
          }
          resolve(reasonList);
        })
        .catch((httpException) => {
          this.$alertify.error("Failed to load misroute reasons.!");
          console.error('exception is:::::::::', httpException)
        })
      })
    },

    gethubagainstAWBandPincode(){
      return new Promise(async (resolve, reject) => {
        try{
          this.getShipDataLoader = true;
          if(this.txtShipment != '') {
            // if(this.isGeoFlowEnabled === false && this.pincodeDerivedFrom != 'UserPincode'){
            //   await this.misrouteMetaDataLoggingAPI();
            // }
            this.ReasonLoader = this.loader;
            this.isHubLoading = true;
            let Payload = {
              shippingID: this.txtShipment,
            }

            if(this.txtPincode){
              Payload.pincode = this.txtPincode;
            }
            if(this.RDHubID){
              Payload.HubId = this.RDHubID;
            }
            let pincodeWiseHubRes = await axios({
              method: 'POST',
              url: apiUrl.api_url + 'shipmentmisroute/pincodeandawbwisehub',
              data: Payload
            })
            if(pincodeWiseHubRes){
              let response = pincodeWiseHubRes;
            // .then(async (response) => {
              if(response.data.code===200){
                if(response.data.data.shipmentCityInfo.data[0].CityId == response.data.data.hubCityId){
                  this.hub = response.data.data.hubName;
                  this.hubid = response.data.data.hubId;
                }
                else if(response.data.data.shipmentCityInfo.data[0].CityId !== response.data.data.hubCityId){
                  this.hub = response.data.data.hubName;
                  this.hubid = response.data.data.hubId;
                }
                // if(!this.isGeoFlowEnabled){
                //   this.pincodeDerivedFrom = 'UserPincode';
                // }
                // await this.misrouteMetaDataLoggingAPI();
                this.isHubLoading = false;
                this.ReasonLoader = '';
                this.getShipDataLoader = false;
                return resolve(true);
              }
              else {
                if(response.data.code==400){
                  this.$alertify.error(response.data.message.details[0].message);
                }
                else {
                  this.$alertify.error(response.data.message);
                }
                this.isCorrectPinInput = true;
                this.pincodeDerivedFrom = 'UserPincode';
                this.txtPincode = '';
                this.hub= '';
                this.hubid= '';
                this.isGeoPincodesAndHub = false;
                this.geoPincode = '';
                this.isHubLoading = false;
                this.ReasonLoader = '';
                this.getShipDataLoader = false;
                return resolve(true);
              }
            // })
            // .catch((httpException) => {
            //   this.$alertify.error("Please provide valid AWB/Pincode");
            //   this.isHubLoading = false;
            //   this.ReasonLoader = '';
            //   this.getShipDataLoader = false;
            //   console.error('exception is:::::::::', httpException)
            //   return resolve(true);
            // })
            }
          }else {
            this.getShipDataLoader = false;
            this.$alertify.error('Please enter shipping id.!');
            return resolve(true);
          }
        }
        catch(e){
          this.$alertify.error("Please provide valid AWB/Pincode");
          this.isHubLoading = false;
          this.ReasonLoader = '';
          this.getShipDataLoader = false;
          console.error('exception is:::::::::', e)
          return resolve(true);
        }
      })
    },

    async getShipmentData(){
      try{
        this.getShipDataLoader = true;
        this.moreShipLink = false;
        this.ReqMisrouteShipsArray = [];
        if(this.txtShipment){
          let getShipDataRes = await axios.post(apiUrl.api_url + 'shipmentmisroute/get/shipmentdata', {"ShippingID":this.txtShipment,"requestedBy":this.createdBy})
          if(getShipDataRes){
            let response = getShipDataRes;
            applySmartInputStyles(document.getElementById('txtShipment'), response.data.lossCategorization);
          // .then(async (response) => {
            if(response.data.code===200 && response.data.data.ShipmentDetails){
              this.ShipmentDetails = response.data.data.ShipmentDetails;
              this.CurrentAddress = this.ShipmentDetails.CustomerAddressDetails.Primary.Address;
              this.CurrentPincode = this.ShipmentDetails.CustomerAddressDetails.Primary.PinCode;
              this.CurrentDestSVC = this.ShipmentDetails.CurrentHubName;
              this.ReqShipmentType = this.ShipmentDetails.LMShipmentType;
              this.misrouteCount = (this.ReqShipmentType.toLowerCase() == 'delivery' || this.ReqShipmentType == 'rvp') ? this.ShipmentDetails.ODAMisrouteCount : this.ShipmentDetails.ODADTORTOMisrouteCount;
              this.RejectionCount = this.ShipmentDetails.rejectioncount ? this.ShipmentDetails.rejectioncount : 0;

              if((this.ReqShipmentType.toLowerCase() == 'rto' || this.ReqShipmentType.toLowerCase() == 'dto') && !this.misrouteRtoDtoFlag){
                this.$alertify.error("Unable to process RTO/DTO shipment as user/hub is not authorized for RTO/DTO Maker-Checker Module.!");
                this.ShipmentDetails = [];
                this.IsValidationError = true;
                this.clearMisrouteForm();
              }
              else if((this.ReqShipmentType.toLowerCase() == 'delivery') && !this.misrouteFlagDel){
                this.$alertify.error('Unable to process Delivery shipment as user/hub is not authorized for Delivery Maker-Checker Module.!')
                this.$router.push('/MarkingMisrouteODA')
                return false;
              }
              else if((this.ReqShipmentType.toLowerCase() == 'rvp') && !this.misrouteFlagRvp){
                this.$alertify.error('Unable to process RVP shipment as user/hub is not authorized for RVP Maker-Checker Module.!')
                this.$router.push('/MarkingMisrouteODA')
                return false;
              }

              await this.validateGeoBasedDataForLogging(this.ShipmentDetails,this.isGeoFlowEnabled);

              if(this.ReqShipmentType.toLowerCase() == 'rto' || this.ReqShipmentType.toLowerCase() == 'dto'){
                this.isRTODTO = true;
                this.ReqVendorName = this.ShipmentDetails.RTODetails.Addresses[0].Name;
                this.ReqVendorAddr = this.ShipmentDetails.RTODetails.Addresses[0].Address;
                this.RTOPincode = this.ShipmentDetails.RTODetails.Addresses[0].PinCode;
                this.CurrentPincode = this.RTOPincode;
                let sameVendorDetailsRes = await this.getSameVendorShipmentList();
                this.sameVendorShipCount = sameVendorDetailsRes.count;
                this.sameVendorShipList = sameVendorDetailsRes.rows;
                // console.log("this.sameVendorShipList::::",JSON.stringify(this.sameVendorShipList));
                if(sameVendorDetailsRes && this.sameVendorShipCount > 0){
                  this.sameVendorShipList.forEach(element =>{
                    element.ShipmentType = (element.ShipmentType.toLowerCase() == 'forward' || element.ShipmentType.toLowerCase() == 'rto') ? 'RTO' : 'DTO'
                  })
                  this.showSameVendorShipPopup();
                }
                else{
                  this.sameVendorShipList = [];
                  let singleShipReqObj = {
                    shippingid : this.txtShipment,
                    LMShipmentType: this.ReqShipmentType
                  }
                  this.ReqMisrouteShipsArray.push(singleShipReqObj);
                }
              }
              else{
                this.isRTODTO = false;
                let singleShipReqObj = {
                  shippingid : this.txtShipment,
                  LMShipmentType: this.ReqShipmentType
                }
                this.ReqMisrouteShipsArray.push(singleShipReqObj);
                // console.log("single req arr:::",this.ReqMisrouteShipsArray);
              }
              this.pushMisrouteShipDataToUF();
              this.getMisrouteReasonsByType(this.isRTODTO);
              this.getShipDataLoader = false;
            }
            else {
              this.ShipmentDetails = [];
              this.$alertify.error(response.data.message);
              this.IsValidationError = true;
              this.clearMisrouteForm();
              this.getShipDataLoader = false;
            }
          // })
          // .catch((httpException) => {
          //   this.$alertify.error("Shipments data not found");
          //   console.error('exception is:::::::::', httpException)
          //   this.getShipDataLoader = false;
          // })
          }
        }
      }
      catch(e){
        this.$alertify.error("Shipments data not found");
        console.error('exception is:::::::::', e)
        this.getShipDataLoader = false;
      }
    },
//function for Api call 
    async pushMisrouteShipDataToUF(){
      try{
        let reqShipDataForUF = [this.txtShipment];
        //created an array for rto/dto shipment type with same vendor shipments   
        if (["rto", "dto"].includes(this.ReqShipmentType.toLowerCase()) && this.sameVendorShipList.length > 0) {
          let sameVendorShipData = this.sameVendorShipList.map(item => item.ShippingID);
          reqShipDataForUF = [...reqShipDataForUF, ...sameVendorShipData];
        }
        let reqShipTypeUF = this.ReqShipmentType &&  this.ReqShipmentType == 'Delivery' ? 'Forward' : this.ReqShipmentType == 'RVP' ? 'Reverse' : this.ReqShipmentType;
      
        let Payload = {
          "ShippingIDs": reqShipDataForUF,
          "MisrouteShipmentType": reqShipTypeUF,
          "LastModifiedBy": this.localusermailid,
          "HubID": this.currentHubID
        };
        let result = await axios.post(apiUrl.api_url + 'misroute/pushreqdatatouf', Payload);
      }
      catch(e){
        console.log("catch block pushMisrouteShipDataToUF",e)
      }
    },

    validateGeoBasedDataForLogging(ShipmentDetails, isGeoEnabledForUI){
      return new Promise(async (resolve, reject) => {
        if(isGeoEnabledForUI === true){
          let validateRes = await this.validateGeoBasedData(ShipmentDetails);
          return resolve(validateRes);
        }
        else{
          this.isCorrectPinInput = true;
          this.pincodeDerivedFrom = await this.skipGeoBasedDataUIValidation(ShipmentDetails);
          return resolve(true);
        }
      })
    },

    //function uses the UI validation/flow of GEO and also geobased data logging...
    validateGeoBasedData(ShipmentDetails){
      return new Promise(async (resolve, reject) => {
        let geoApiData = ShipmentDetails.geoAPIData;
        let geoCoordinateBasedData = ShipmentDetails.geoCoordinateBased;
        this.isGeoPincodesAndHub = (geoCoordinateBasedData.geohubid && geoCoordinateBasedData.pincodelist && geoCoordinateBasedData.pincodelist.length > 0) ? true : false;
        if(this.isGeoPincodesAndHub == true && this.ReqShipmentType.toLowerCase() == 'delivery'){
          this.isCorrectPinInput = false;
          this.hub = this.ShipmentDetails.geoCoordinateBased.geohubname;
          this.hubid = this.ShipmentDetails.geoCoordinateBased.geohubid;
          this.pincodeDerivedFrom = 'GeoCluster';

          let geoPincodesList = this.ShipmentDetails.geoCoordinateBased.pincodelist;
          for (var i = 0; i < geoPincodesList.length; i++) {
            if(geoPincodesList[i].toString().length == 6){
              this.geoPincodeList.push({
                text: `${geoPincodesList[i]}`
              })
            }
          }
          return resolve(true);
        }
        else if(this.isGeoPincodesAndHub == false && this.ReqShipmentType.toLowerCase() == 'delivery' && geoApiData.isDestChange == "false"){
          this.pincodeDerivedFrom = 'GeoPincode';
          if(geoApiData.updatedPincode && geoApiData.updatedPincode.length == 6){
            this.isCorrectPinInput = false;
            this.txtPincode = geoApiData.updatedPincode.toString();
            await this.gethubagainstAWBandPincode();
          }
          else if((!geoApiData.updatedPincode || geoApiData.updatedPincode == '0') && geoApiData.originalPincode && geoApiData.originalPincode.length == 6){
            this.isCorrectPinInput = false;
            this.txtPincode = geoApiData.originalPincode.toString();
            await this.gethubagainstAWBandPincode();
          }
          else{
            this.pincodeDerivedFrom = 'UserPincode';
            this.isCorrectPinInput = true;
            this.txtPincode = '';
          }
          return resolve(true);
        }
        else{
          this.pincodeDerivedFrom = 'UserPincode';
          this.isCorrectPinInput = true;
          this.txtPincode = '';
          return resolve(true);
        }
      })
    },

    //function to skip UI validation/flow of GEO but will do logging as per the GEO...
    skipGeoBasedDataUIValidation(ShipmentDetails){
      return new Promise(async (resolve, reject) =>{
        let pinDerivedFrom = '';
        this.isGeoPincodesAndHub = (ShipmentDetails.geoCoordinateBased.geohubid && ShipmentDetails.geoCoordinateBased.pincodelist && ShipmentDetails.geoCoordinateBased.pincodelist.length > 0) ? true : false;
        if(this.isGeoPincodesAndHub == true && this.ReqShipmentType.toLowerCase() == 'delivery'){
          pinDerivedFrom = 'GeoCluster';
        }
        else if(this.isGeoPincodesAndHub == false && ShipmentDetails.geoAPIData.isDestChange == "false" && this.ReqShipmentType.toLowerCase() == 'delivery'){
          pinDerivedFrom = 'GeoPincode';
        }
        else{
          pinDerivedFrom = 'UserPincode';
        }
        return resolve(pinDerivedFrom);
      })
    },

    //only used for skipGeoBasedDataUIValidation...
    getPincodeWiseHubDetailsForGEO(pincode){
      return new Promise(async (resolve, reject) =>{
        axios.post(apiUrl.api_url + 'shipmentMisrout/pincodeandawbwisehub', {
          "shippingID":this.txtShipment,
          "pincode": pincode
        }).then((response) => {
          if(response.data.code===200){
            let result = {
              "hubName" : response.data.data.hubName,
              "hubId" : response.data.data.hubId,
            }
            resolve(result);
          }
          else{
            resolve(false);
          }
        })
      })
    },

    async selectGeoPincode(obj){
      this.geoPincodeObj = obj;
      this.geoPincode = obj.text;
      // if(this.geoPincode){
      //   await this.misrouteMetaDataLoggingAPI();
      // }
    },

    misrouteMetaDataLoggingAPI(){
      return new Promise(async (resolve, reject) =>{
        try{
          let loggingAPIPayload = {
            "ShippingId": this.txtShipment.trim(),
            "shipmentType": this.ReqShipmentType,
            "logDataObj": {
              "currentHubId": this.currentHubID,
              "currentPincode": this.CurrentPincode,
              "currentAddress": this.CurrentAddress,
              "misroutecount": (this.misrouteCount == null) ? 0 : this.misrouteCount
            },
            "misrouteMetadataSource": this.pincodeDerivedFrom,
            "userId": this.localuserid,
            "LastModifiedBy": this.localusermailid,
            "requestedFrom": "NewModule",
            // "isShadowModeOff": this.isGeoFlowEnabled
          }
          if(this.isGeoFlowEnabled === true){
            loggingAPIPayload.logDataObj.suggestedHubId = this.hubid;
            loggingAPIPayload.logDataObj.suggestedHub = this.hub;
            loggingAPIPayload.logDataObj.suggestedPincode = (this.txtPincode=='')?null:this.txtPincode;
            if(this.isGeoPincodesAndHub == true && this.geoPincode){
              loggingAPIPayload.logDataObj.suggestedPincode = this.geoPincode;
            }
          }
          else{
            if(this.isGeoPincodesAndHub == true && (!this.hubid || !this.hub)){
              loggingAPIPayload.logDataObj.suggestedHubId = this.ShipmentDetails.geoCoordinateBased.geohubid;
              loggingAPIPayload.logDataObj.suggestedHub = this.ShipmentDetails.geoCoordinateBased.geohubname;
              loggingAPIPayload.logDataObj.suggestedPincode = this.ShipmentDetails.geoCoordinateBased.pincodelist[0];
              loggingAPIPayload.isShadowModeOff = this.isGeoFlowEnabled;
            }
            else if(this.isGeoPincodesAndHub == false && this.ShipmentDetails.geoAPIData.isDestChange == "false" && (!this.hubid || !this.hub)){
              if(this.ShipmentDetails.geoAPIData.updatedPincode && this.ShipmentDetails.geoAPIData.updatedPincode.length == 6){
                let hubDetails = await this.getPincodeWiseHubDetailsForGEO(this.ShipmentDetails.geoAPIData.updatedPincode);
                loggingAPIPayload.logDataObj.suggestedHubId = hubDetails.hubId ? hubDetails.hubId : null;
                loggingAPIPayload.logDataObj.suggestedHub = hubDetails.hubName ? hubDetails.hubName : null;
                loggingAPIPayload.logDataObj.suggestedPincode = this.ShipmentDetails.geoAPIData.updatedPincode;
              }
              else if((!this.ShipmentDetails.geoAPIData.updatedPincode || this.ShipmentDetails.geoAPIData.updatedPincode == '0') && this.ShipmentDetails.geoAPIData.originalPincode && this.ShipmentDetails.geoAPIData.originalPincode.length == 6){
                let hubDetails = await this.getPincodeWiseHubDetailsForGEO(this.ShipmentDetails.geoAPIData.originalPincode);
                loggingAPIPayload.logDataObj.suggestedHubId = hubDetails.hubId ? hubDetails.hubId : null;
                loggingAPIPayload.logDataObj.suggestedHub = hubDetails.hubName ? hubDetails.hubName : null;
                loggingAPIPayload.logDataObj.suggestedPincode = this.ShipmentDetails.geoAPIData.originalPincode;
              }
              else{
                loggingAPIPayload.logDataObj.suggestedHubId = this.hubid;
                loggingAPIPayload.logDataObj.suggestedHub = this.hub;
                loggingAPIPayload.logDataObj.suggestedPincode = this.txtPincode;
              }
              loggingAPIPayload.isShadowModeOff = this.isGeoFlowEnabled;
            }
            else{
              loggingAPIPayload.logDataObj.suggestedHubId = this.hubid;
              loggingAPIPayload.logDataObj.suggestedHub = this.hub;
              loggingAPIPayload.logDataObj.suggestedPincode = this.txtPincode;
              loggingAPIPayload.isShadowModeOff = true;
            }
          }

          let logApiRes = await axios.post(apiUrl.api_url + 'misroute/general/metadatasource/logging', loggingAPIPayload)
          if(logApiRes){
            let response = logApiRes;
          // .then((response) => {
            if(response.data.code != 200 && this.ReqShipmentType.toLowerCase() == 'delivery'){
              this.$alertify.warning("Logging the details");
              resolve(true);
            }
            resolve(true);
          }
          // })
          // .catch((e) => {
          //   console.log('error in misrouteMetaDataLoggingAPI :', e);
          //   resolve(false);
          // });
        }
        catch(e){
          console.log('error in misrouteMetaDataLoggingAPI :', e);
          resolve(false);
        }
      })
    },

    async getSameVendorShipmentList(){
      return new Promise((resolve,reject)=> {
        let Payload = {
          "shippingId": this.txtShipment,
          "currentHubID": this.currentHubID,
          "vendorName": this.ReqVendorName,
          "vendorAddress": this.ReqVendorAddr
        }
        axios({
          method: 'POST',
          url: apiUrl.api_url + 'misroute/general/getsamevendorshipments',
          data: Payload
        })
        .then(result => {
          if (result.data.code == 200) {
            return resolve(result.data.data);
          }
          else{
            return resolve(false);
          }
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException);
          return resolve(false);
        })
      })
    },

    showSameVendorShipPopup(){
      let message = {
        // title: `<center><p>Confirmation</p></center>`,
        body: `<p>${this.sameVendorShipCount} more shipments found for the same vendor and vendor address combination:</p>
        <p>Vendor: <b>${this.sameVendorShipList[0].RTOName}</b></p>
        <p>Address: <b>${this.sameVendorShipList[0].RTOAddress}</b></p>`,
      };
      this.$dialog.confirm(message, {
        html: true,
        animation: 'bounce',
        backdropClose: true,
        cancelText: 'Cancel',
        okText: 'Include All for Misroute Request',
        reverse: false,
        loader: true
      })
      .then(dialog=>{
        // this.moreShipmentsList = true;
        this.moreShipLink = true;
        let reqShipObj = {
          shippingid : this.txtShipment,
          LMShipmentType: this.ReqShipmentType
        }
        this.ReqMisrouteShipsArray.push(reqShipObj);
        for (let i = 0; i < this.sameVendorShipCount; i++) {
          let sameVendorShipmentObj = {
            shippingid: this.sameVendorShipList[i].ShippingID,
            LMShipmentType: this.sameVendorShipList[i].ShipmentType
          }
          this.ReqMisrouteShipsArray.push(sameVendorShipmentObj);
          console.log("Bulk ReqMisrouteShipsArray::::::",JSON.stringify(this.ReqMisrouteShipsArray));
        }
        dialog.close();
      })
    },

    showMoreShipmentsList(reqId) {
      if(this.txtShipment && this.sameVendorShipCount > 0 && this.moreShipLink){
        this.MoreShipmentModel = true;
      }
      else if(this.ActiveTabIndex == 1){
        this.moreShipmentsColumns[1].key = 'vendorname'
        this.moreShipmentsColumns[0].key = 'shipmenttype'
        this.getSameReqIdShipments(reqId);
        this.MoreShipmentModel = true;
      }
      else{
        this.MoreShipmentModel = false;
      }
    },
    CloseMoreShipmentModel(){
      this.MoreShipmentModel = false;
      this.moreShipmentsColumns[1].key = 'RTOName';
      this.moreShipmentsColumns[0].key = 'ShipmentType'
    },
    getSameReqIdShipments(reqId){
      this.MultiShipmentloader = true;
      this.sameVendorShipList = [];
      let Payload = {
        "requestId": reqId
      }
      axios({
        method: 'POST',
        url: apiUrl.api_url + 'misroute/general/getsamerequests/shipments',
        data: Payload
      })
      .then(result => {
        if (result.data.code == 200) {
          this.sameVendorShipList = result.data.data;
        }
        else{
          this.sameVendorShipList = [];
        }
        this.MultiShipmentloader = false;
      })
      .catch((httpException) => {
        this.sameVendorShipList = [];
        this.MultiShipmentloader = false;
        console.error('exception is:::::::::', httpException);
      })
    },

    tabWiseShipmentsCount(){
      let Payload = {
        "hubId": this.currentHubID,
        "isMaker": true
      }
      axios({
        method: 'POST',
        url: apiUrl.api_url + 'misroute/general/getcountagainststatus',
        data: Payload
      })
      .then(result => {
        if (result.data.code == 200) {
          this.unAssTabShipCount = result.data.data.unAssignedCount;
          this.pendignShipCount = result.data.data.pendingCount;
          this.acceptedShipCount = result.data.data.acceptedCount;
          this.rejectedShipCount = result.data.data.rejectedCount;
          this.rejectedByMdMCount = result.data.data.rejectedByMdMCount;
          this.rejectedBySVCCount = result.data.data.rejectedBySVCCount;
          this.allReqCount = result.data.data.allReqCount;
        }
        else{
          this.unAssTabShipCount = 0;
          this.pendignShipCount = 0;
          this.acceptedShipCount = 0;
          this.rejectedShipCount = 0;
          this.rejectedByMdMCount = 0;
          this.rejectedBySVCCount = 0;
          this.allReqCount = 0;
        }
      })
      .catch((httpException) => {
        this.$alertify.error("Data not found.!");
        console.error('exception is:::::::::', httpException)
      })
    },

    //function for All search filters...
    searchByFilters(){
      this.Shipmentloader = true;
      this.AllReqPageNo = 1;
      this.PendingPageNo = 1;
      this.AcceptedPageNo = 1;
      this.RejectedPageNo = 1;
      this.$refs.AllReqpaginate.selected= 0;
      this.$refs.PendingReqpaginate.selected= 0;
      this.$refs.AccReqpaginate.selected= 0;
      this.$refs.RejReqpaginate.selected= 0;

      this.searchByDateFilter();
      if(this.ActiveTabIndex1 == 0 && this.awbArray || this.MisrouteType || this.MisrouteReason || this.currentFromDate || this.currentToDate){
        this.getAllReqList();
      }
      if(this.ActiveTabIndex1 == 1 && this.awbArray1 || this.MisrouteType1 || this.MisrouteReason1 || this.currentFromDate1 || this.currentToDate1){
        this.getPendingReqList();
      }
      if(this.ActiveTabIndex1 == 2 && this.awbArray2 || this.MisrouteType2 || this.MisrouteReason2 || this.currentFromDate2 || this.currentToDate2){
        this.getAcceptedReqList();
      }
      if(this.ActiveTabIndex1 == 3 && this.awbArray3 || this.MisrouteType3 || this.MisrouteReason3 || this.currentFromDate3 || this.currentToDate3){
        this.getRejectedReqList();
      }
    },

    //FromDate ToDate validations
    checkFromDate() {
      this.todate = '';
      let todaysDate = moment().format('YYYY-MM-DD');
      this.selectedFromDate = moment.utc(this.fromdate).format("YYYY-MM-DD").valueOf();
      this.todate = this.fromdate;
      if (this.fromdate > todaysDate) {
        this.$alertify.error("FromDate should be less than todays date.!")
        this.fromdate = null;
        this.todate = null;
      }
      else {
        this.validDateRange = this.selectedFromDate
      }
    },
    checkToDate() {
      let todaysDate = moment().format('YYYY-MM-DD');
      this.validDateRangeFrom = moment.utc(this.todate).format("YYYY-MM-DD").valueOf();
      if (this.todate != null && this.todate > todaysDate) {
        this.$alertify.error("ToDate should be greater than from date")
        this.todate = null;
      }
    },

    //function for Date filter...
    searchByDateFilter(){
      if(this.ActiveTabIndex1 == 0 && (this.fromdate || this.todate)){
        if(this.fromdate != null){
          this.currentFromDate =  this.fromdate;
          this.currentToDate = null;
        }
        if(this.todate != null){
          this.currentToDate =  this.todate;
        }
        this.currentFromDate1 = '';
        this.currentFromDate2 = '';
        this.currentFromDate3 = '';
        this.currentToDate1 = '';
        this.currentToDate2 = '';
        this.currentToDate3 = '';
      }
      if(this.ActiveTabIndex1 == 1 && (this.fromdate || this.todate)){
        if(this.fromdate){
          this.currentFromDate1 =  moment(this.fromdate).format('YYYY-MM-DD');
        }
        if(this.todate){
          this.currentToDate1 =  moment(this.todate).format('YYYY-MM-DD');
        }
        this.currentFromDate2 = '';
        this.currentFromDate2 = '';
        this.currentFromDate3 = '';
        this.currentToDate3 = '';
        this.currentFromDate = '';
        this.currentToDate = '';
      }
      if(this.ActiveTabIndex1 == 2 && (this.fromdate || this.todate)){
        if(this.fromdate){
          this.currentFromDate2 =  moment(this.fromdate).format('YYYY-MM-DD');
        }
        if(this.todate){
          this.currentToDate2 =  moment(this.todate).format('YYYY-MM-DD');
        }
        this.currentFromDate1 = '';
        this.currentFromDate = '';
        this.currentToDate = '';
        this.currentToDate1 = '';
        this.currentToDate3 = '';
        this.currentFromDate3 = '';
      }
      if(this.ActiveTabIndex1 == 3 && (this.fromdate || this.todate)){
        if(this.fromdate){
          this.currentFromDate3 =  moment(this.fromdate).format('YYYY-MM-DD');
        }
        if(this.todate){
          this.currentToDate3 =  moment(this.todate).format('YYYY-MM-DD');
        }
        this.currentFromDate1 = '';
        this.currentFromDate2 = '';
        this.currentFromDate = '';
        this.currentToDate = '';
        this.currentToDate1 = '';
        this.currentToDate2 = '';
      }
    },

    //common function to get shippingids array...
    getShippingIdsArr(shipments){
      // console.log("shipments::::::::",shipments);
      let shipArray = [];

      let shippingidsWithNextLine = shipments.split("\n").map(String);
      let shippingidsWithComma = shipments.split(",").map(String);
      if(shippingidsWithNextLine.length > 1) {
        $.each(shippingidsWithNextLine, (key,sid)=>{
          if(sid != null && sid !=''){
            shipArray.push(sid.trim());
          }
        })
      }
      else if(shippingidsWithComma.length >= 1){
        $.each(shippingidsWithComma, (key,sid)=>{
          if(sid != null && sid !=''){
            shipArray.push(sid.trim());
          }
        })
      }
      return shipArray;
    },

    //Common get data api call for All tabs...
    commonGetApiCall(payload){
      axios({
        method: 'POST',
        url: apiUrl.api_url + 'shipmentmisroute/get/requests/data',
        data: payload
      })
      .then(result => {
        if (result.data.code==200) {
          this.showShipmentReqList = result.data.data.rows;
          this.ShipmentCount = result.data.data.count;
          let singleReqCount = result.data.data.specificcount.withoutrequest;
          let bulkReqCount = result.data.data.specificcount.withrequest;
          let MaxCount = Math.max(singleReqCount,bulkReqCount);
          if(this.ActiveTabIndex1 == 0){
            this.AllReqPagecount = Math.ceil(MaxCount/this.PageLimit);
          }
          else if(this.ActiveTabIndex1 == 1){
            this.PendingPagecount = Math.ceil(MaxCount/this.PageLimit);
          }
          else if(this.ActiveTabIndex1 == 2){
            this.AcceptedPagecount = Math.ceil(MaxCount/this.PageLimit);
          }
          else if(this.ActiveTabIndex1 == 3){
            this.RejectedPagecount = Math.ceil(MaxCount/this.PageLimit);
          }
        }
        else{
          this.ShipmentCount = 0;
          if(this.ActiveTabIndex1 == 0){
            this.AllReqPagecount = 1;
          }
          else if(this.ActiveTabIndex1 == 1){
            this.PendingPagecount = 1;
          }
          else if(this.ActiveTabIndex1 == 2){
            this.AcceptedPagecount = 1;
          }
          else if(this.ActiveTabIndex1 == 3){
            this.RejectedPagecount = 1;
          }
          // this.$alertify.error(result.data.message);
        }
        this.Shipmentloader = false;
      }, error => {
        this.Shipmentloader = false;
        console.error(error)
      })
    },

    getAllReqList(){
      this.ShowAllReqModel = true;
      this.Shipmentloader = true;
      this.showShipmentReqList = [];
      this.ShipmentCount = 0;
      if(this.SearchShip){
        this.awbArray = this.getShippingIdsArr(this.SearchShip);
      }

      let payload = {
        "HubId": this.currentHubID,
        "isAll" : '1',
        "limit": '40',
        "pageNo": this.AllReqPageNo.toString(),
      }
      if(this.awbArray && this.SearchShip.trim()){
        payload.ShippingIDs = this.awbArray;
      }
      if(this.ShipmentType){
        payload.shipmenttype = this.ShipmentType;
      }
      if(this.MisrouteType){
        payload.MisrouteType = this.MisrouteType.toLowerCase();
      }
      if(this.MisrouteReason){
        payload.MisrouteReason = this.MisrouteReason;
      }
      if(this.currentFromDate){
        payload.FromDate = this.currentFromDate;
      }
      if(this.currentToDate){
        payload.ToDate = this.currentToDate;
      }

      this.commonGetApiCall(payload);
      this.ShowAllReqModel = false;
    },

    getPendingReqList(){
      this.PendingReqModel = true;
      this.Shipmentloader = true;
      this.showShipmentReqList = [];
      this.ShipmentCount = 0;
      if(this.SearchShip1){
        this.awbArray1 = this.getShippingIdsArr(this.SearchShip1);
      }

      let payload = {
        "HubId": this.currentHubID,
        "Status": "Pending",
        "limit": '40',
        "pageNo": this.PendingPageNo.toString(),
      }
      if(this.awbArray1 && this.SearchShip1.trim()){
        payload.ShippingIDs = this.awbArray1;
      }
      if(this.ShipmentType1){
        payload.shipmenttype = this.ShipmentType1;
      }
      if(this.MisrouteType1){
        payload.MisrouteType = this.MisrouteType1.toLowerCase();
      }
      if(this.MisrouteReason1){
        payload.MisrouteReason = this.MisrouteReason1;
      }
      if(this.currentFromDate1){
        payload.FromDate = this.currentFromDate1;
      }
      if(this.currentToDate1){
        payload.ToDate = this.currentToDate1;
      }

      this.commonGetApiCall(payload);
      // this.Shipmentloader = false;
      this.PendingReqModel = false;
    },

    getAcceptedReqList(){
      this.AcceptedReqModel = true;
      this.Shipmentloader = true;
      this.showShipmentReqList = [];
      this.ShipmentCount = 0;
      if(this.SearchShip2){
        this.awbArray2 = this.getShippingIdsArr(this.SearchShip2);
      }

      let payload = {
        "HubId": this.currentHubID,
        "Status": "Accepted",
        "limit": '40',
        "pageNo": this.AcceptedPageNo.toString(),
      }
      if(this.awbArray2 && this.SearchShip2.trim()){
        payload.ShippingIDs = this.awbArray2;
      }
      if(this.ShipmentType2){
        payload.shipmenttype = this.ShipmentType2;
      }
      if(this.MisrouteType2){
        payload.MisrouteType = this.MisrouteType2.toLowerCase();
      }
      if(this.MisrouteReason2){
        payload.MisrouteReason = this.MisrouteReason2;
      }
      if(this.currentFromDate2){
        payload.FromDate = this.currentFromDate2;
      }
      if(this.currentToDate2){
        payload.ToDate = this.currentToDate2;
      }

      this.commonGetApiCall(payload);
      // this.Shipmentloader = false;
      this.AcceptedReqModel = false;
    },

    getRejectedReqList(){
      this.RejectedReqModel = true;
      this.Shipmentloader = true;
      this.showShipmentReqList = [];
      this.ShipmentCount = 0;
      if(this.SearchShip3){
        this.awbArray3 = this.getShippingIdsArr(this.SearchShip3);
      }

      let payload = {
        "HubId": this.currentHubID,
        "Status": "Rejected",
        "limit": '40',
        "pageNo": this.RejectedPageNo.toString(),
      }
      if(this.rejectedBy == "0"){
        payload.isCheckerSVC = true
      }
      if(this.awbArray3 && this.SearchShip3.trim()){
        payload.ShippingIDs = this.awbArray3;
      }
      if(this.ShipmentType3){
        payload.shipmenttype = this.ShipmentType3;
      }
      if(this.MisrouteType3){
        payload.MisrouteType = this.MisrouteType3.toLowerCase();
      }
      if(this.MisrouteReason3){
        payload.MisrouteReason = this.MisrouteReason3;
      }
      if(this.currentFromDate3){
        payload.FromDate = this.currentFromDate3;
      }
      if(this.currentToDate3){
        payload.ToDate = this.currentToDate3;
      }

      this.commonGetApiCall(payload);
      // this.Shipmentloader = false;
      this.RejectedReqModel = false;
    },

    getTablePaginationData(pageNum) {
      if(this.ActiveTabIndex1 == 0){
        this.AllReqPageNo = pageNum;
        this.getAllReqList();
      }
      if(this.ActiveTabIndex1 == 1){
        this.PendingPageNo = pageNum;
        this.getPendingReqList();
      }
      if(this.ActiveTabIndex1 == 2){
        this.AcceptedPageNo = pageNum;
        this.getAcceptedReqList();
      }
      if(this.ActiveTabIndex1 == 3){
        this.RejectedPageNo = pageNum;
        this.getRejectedReqList();
      }
    },

    withDrawReq(shipDetails) {
      this.withdrawReqLoader = true;

      let payload = {
        "currentHubId": this.currentHubID,
        "CurrHubCityId": shipDetails.currenthubcityid,
        "currentPincode": shipDetails.currentpincode,
        "SuggestedHubId": shipDetails.suggestedhubid,
        "suggestedPincode": shipDetails.suggestedpincode,
        "RaisedbyUserId": shipDetails.raisedbyuserid,
        "LastModifiedBy": this.localusermailid,
      }
      if(shipDetails.requestid != null){
        payload.requestId = shipDetails.requestid
      }
      else{
        payload.ShippingId = shipDetails.shippingid
      }

      axios({
        method: 'POST',
        url: apiUrl.api_url + 'shipmentmisroute/remove/request',
        data: payload
      })
      .then(result => {
        if (result.data.code==200) {
          this.$alertify.success(result.data.message);
          if(this.ActiveTabIndex1 == 0){
            this.getAllReqList();
          }
          if(this.ActiveTabIndex1 == 1){
            this.getPendingReqList();
          }
          this.tabWiseShipmentsCount();
        } else {
          this.$alertify.error(result.data.message!='' && result.data.message!=undefined?result.data.message:'Not getting any response message.')
        }
        this.withdrawReqLoader = false;
      }, error => {
        this.withdrawReqLoader = false;
        console.error(error)
      })
      this.withdrawReqLoader = false;
    },

    raiseRejRequestToSVCorCLT(shipDetails){
      // console.log("selectedItems:::",JSON.stringify(selectedItems));
      this.rejReqLoader = true;
      let rejectioncount = shipDetails.rejectioncount ? shipDetails.rejectioncount : 0
      let payload = {
        "RejectedCount": rejectioncount,
        "LastModifiedBy": this.localusermailid,
        "currentHubId": this.currentHubID,
        "CurrHubCityId": shipDetails.currenthubcityid,
        "currentPincode": shipDetails.currentpincode,
        "SuggestedHubId": shipDetails.suggestedhubid,
        "suggestedPincode": shipDetails.suggestedpincode,
        "RaisedbyUserId": shipDetails.raisedbyuserid,
        "shipmenttype": shipDetails.shipmenttype,
        "vendorname": shipDetails.vendorname,
        "vendoraddress": shipDetails.vendoraddress,
      }
      if(shipDetails.requestid != null){
        payload.requestId = shipDetails.requestid
      }
      else{
        payload.ShippingId = shipDetails.shippingid
      }

      axios({
        method: 'POST',
        url: apiUrl.api_url + 'misroute/maker/raise/request',
        data: payload
      })
      .then(result => {
        if(result.data.code == 200){
          this.$alertify.success(result.data.message);
          this.tabWiseShipmentsCount();
          this.getRejectedReqList();
        }
        else{
          this.$alertify.error(result.data.message!='' && result.data.message!=undefined ? result.data.message : 'Not getting any response message.')
        }
      })
      this.rejReqLoader = false
    },

    getHubList(){
      this.HubLoader = this.loader;
        axios.get(apiUrl.api_url + 'shipmentmisroute/gethublist', {})
        .then((response) => {
            if(response.data.code===200){
              this.getHubObj =response.data.data;
              let resLength = response.data.data.length;
              for (let i = 0; i < resLength; i++) {
                this.HubList.push({
                  value: response.data.data[i].HubID,
                  text: `${response.data.data[i].HubName}`,
                });
              }
            }
            else {
              this.getHubObj=[];
            }
            this.HubLoader = '';
        })
        .catch((httpException) => {
          this.HubLoader = '';
          this.$alertify.error("shipmentstatus data not found");
          console.error('exception is:::::::::', httpException)
        })
    },

    selectHub(obj){
      this.HubObj = obj;
      this.ddlHub = obj.text;
      if(this.isRTODTO){
        this.RDHubID = obj.value;
        if(this.isRTODTOReason){
          this.txtPincode = this.RTOPincode.toString();
          // this.gethubagainstAWBandPincode()
        }
      }
    },

    onlyNumber($event){
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57 ) && keyCode !== 8 && keyCode !== 44) {
        $event.preventDefault();
      }
    },

    validateForm(scope) {
      this.$validator.validateAll(scope).then(result => {
        if(result){
          if(this.isRTODTO && this.sameVendorShipCount > 0 && !this.moreShipLink){
            this.showSameVendorShipPopup();
          }
          if(!this.isRTODTO || (this.isRTODTO && this.moreShipLink) || (this.isRTODTO && !this.moreShipLink && !this.sameVendorShipCount)){
            let message = {};
            if(this.isRTODTO && this.moreShipLink){
              message = {
                title: `<center><p>Confirmation</p></center>`,
                body: `<center><p>Do you want to submit all the shipments with</p></center>
                <center><p>VendorName: <b>${this.ReqVendorName}</b></p>
                <p> VendorAddress: <b>${this.ReqVendorAddr}</b></p></center>`,
              };
            }
            else{
              message = {
                title: `<center><p>Confirmation</p></center>`,
                body: `<center><p>Do you want to submit?</p></center>`,
              };
            }
            this.$dialog.confirm(message, {
              html: true,
              animation: 'bounce',
              backdropClose: true,
              okText: 'Yes',
              cancelText: 'No',
              reverse: true,
              loader: true
            })
            .then(dialog=>{
              var markingMisRoutePayload = {
                shipmenttype : '2',
                markShipmentStatus : 'XBU00260',
                reason : this.ReqMisrouteReason,
                // shippingid :  this.txtShipment.trim(),
                // distance : this.DistanceKm,
                LastModifiedBy : this.localusermailid,
                currentHubID: this.currentHubID,
                userid: this.localuserid,
                rejectioncount: this.RejectionCount,
                bulkshipments : this.ReqMisrouteShipsArray,
                misrouteMetadataSource: this.pincodeDerivedFrom ? this.pincodeDerivedFrom : null
              }
              if(this.ReqShipmentType == 'RTO' || this.ReqShipmentType == 'DTO'){
                markingMisRoutePayload.hubid = this.RDHubID;
                markingMisRoutePayload.pincode = this.txtPincode;
              }
              else{
                markingMisRoutePayload.hubid = this.hubid;
                markingMisRoutePayload.pincode = (this.txtPincode=='')?null:this.txtPincode;
                if(this.isGeoPincodesAndHub == true && this.geoPincode){
                  markingMisRoutePayload.pincode = this.geoPincode;
                }
              }
              // console.log("markingMisRoutePayload:::::::::",JSON.stringify(markingMisRoutePayload));
              this.isSubmitLoading = true;
              axios.post(apiUrl.api_url + 'shipmentmisroute/markshipmentasmisroute', markingMisRoutePayload)
              .then((response) => {
                if(response.data.code == 200){
                  //tracker api called here
                  let TrackerInfo = {
                    projectname:"Last Mile",
                    type:"Web",
                    userid:this.localuserid,
                    username:this.localusermailid,
                    meta: {
                      "event":"MisrouteMakerChecker",
                      "shipment": this.txtShipment.trim().toString(),
                      "markShipmentStatus" : 'XBU00260',
                      "reason" : this.ReqMisrouteReason,
                    }
                  }
                  this.PageTracker(TrackerInfo)
                  //end
                  this.$alertify.success(response.data.message);
                  this.txtShipment = '';
                  this.txtPincode = '';
                  // this.DistanceKm = '';
                  this.$validator.reset();
                  this.errors.clear();
                  this.clearMisrouteForm();
                }
                else if(response.data.code == 204){
                  if(this.ReqMisrouteShipsArray.length > 1){
                    this.dismissCountDown = this.dismissSecs;
                    let errorsCount = response.data.data.error.length;
                    let successCount = response.data.data.success.length;
                    this.requestsErrorMsg = response.data.data.error;
                    this.reqErrorCount = errorsCount;
                    this.reqSuccessCount = successCount;
                  }
                  else{
                    this.$alertify.error(response.data.data.error[0].message);
                  }
                }
                else {
                  this.$alertify.error(response.data.message);
                }
                dialog.close();
                this.isSubmitLoading = false;
                this.clearMisrouteForm();
              })
              .catch((httpException) => {
                dialog.close();
                this.isSubmitLoading = false;
                this.$alertify.error("Unable to Update Record");
                this.clearMisrouteForm();
                console.error('exception is:::::::::',httpException)
              });
            })
          }
        }
      }).catch(() => {
        dialog.close();
        this.isSubmitLoading = false;
        console.log('errors exist', this.errors)
      });
    },

    // OpenSuccessErrorResModel(){
    //   this.successErrorResModel = true;
    // },

    CloseSuccessErrorResModel(){
      this.successErrorResModel = false;
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },

    clearMisrouteForm(){
      this.ReqShipmentType = '',
      this.ReqVendorName = '',
      this.ReqVendorAddr = '',
      this.isRTODTO = false,
      this.RDHubID = '',
      this.RTOPincode = '',
      this.MarkShipmentStatus = '',
      this.ReqMisrouteReason = '',
      this.MisrouteReasonObj ={},
      this.isRTODTOReason = false,
      // this.ODAerror = '',
      this.txtShipment = '',
      this.txtPincode = '',
      this.isCorrectPinInput = false;
      this.isGeoPincodesAndHub = false;
      this.moreShipLink = false,
      this.ReqMisrouteShipsArray = [],
      // this.requestsErrorMsg = [];
      // this.reqErrorCount = '';
      // this.reqSuccessCount = '';
      this.geoPincodeList = [],
      this.geoPincode = '',
      this.geoPincodeObj = {},
      this.pincodeDerivedFrom = '',
      this.misrouteCount = 0,
      this.ddlHub = '',
      this.hub = '',
      this.HubObj = {},
      // this.reasonObj = [],
      this.ReasonLoader = '',
      this.hubFlag = true,
      // this.DistanceKm = '',
      // this.DistanceFlag = false,
      // this.HubLabelFlag = false,
      this.hubDiv = true,
      this.CurrentAddress = '',
      this.CurrentPincode = '',
      this.CurrentDestSVC = '',
      this.IsValidationError = false,
      clearSmartInputStyles(document.getElementById('txtShipment'));
      this.$validator.reset();
      this.errors.clear();
    },

    clear(){
      this.SearchShip = '',
      this.MisrouteType = '',
      this.MisrouteReason = '',
      this.SearchShip1 = '',
      this.MisrouteType1 = '',
      this.MisrouteReason1 = '',
      this.SearchShip2 = '',
      this.MisrouteType2 = '',
      this.MisrouteReason2 = '',
      this.SearchShip3 = '',
      this.MisrouteType3 = '',
      this.MisrouteReason3 = '',
      this.currentFromDate = '',
      this.currentFromDate1 = '',
      this.currentFromDate2 = '',
      this.currentFromDate3 = '',
      this.currentToDate = '',
      this.currentToDate1 = '',
      this.currentToDate2 = '',
      this.currentToDate3 = '',
      this.currentFiltersTab = 'clearFilters',
      this.currentRejScreenTab = 'RejByMDM',
      this.MisroutetypeObj = {};
      this.MisrouteReasonObj = {};
      this.ShipmentType = '';
      this.ShipmentType1 = '';
      this.ShipmentType2 = '';
      this.ShipmentType3 = '';
      this.ShipmentTypeObj = {};
      this.awbArray= [],
      this.awbArray1= [],
      this.awbArray2= [],
      this.awbArray3= []
      this.fromdate = '',
      this.todate = '',
      this.$validator.reset();
      this.errors.clear();
      if(this.ActiveTabIndex == 1 && this.ActiveTabIndex1 == 0){
        this.getAllReqList();
      }
      else if(this.ActiveTabIndex == 1 && this.ActiveTabIndex1 == 1){
        this.getPendingReqList();
      }
      else if(this.ActiveTabIndex == 1 && this.ActiveTabIndex1 == 2){
        this.getAcceptedReqList();
      }
      else if(this.ActiveTabIndex == 1 && this.ActiveTabIndex1 == 3){
        this.GetCurrentRejectedTab('RejByMDM');
      }
    },
  }
}

//extended validation
Validator.extend('IsValidNo', {
  getMessage: field => { return 'Please Enter only number.!'},
  validate: value => {
    let numberRegex = /^[0-9]+$/;
    if(numberRegex.test(value) == true){
      return true;
    } else {
      return false;
    }
  }
})

Validator.extend('IsValidDist', {
  getMessage: field => {return 'Distance cannot be more than 999 KM.!'},
  validate: value => {
    if( value <= 999 ){
      return true;
    } else {
      return false;
    }
  }
})

Validator.extend('IsValidShipment', {
  getMessage: field => {return 'Please Enter Valid AWB.!'},
  validate: value => {
    if(!value || !value.toLowerCase().startsWith('r')){
      return true;
    } else {
      return false;
    }
  }
})



// WEBPACK FOOTER //
// ./src/views/components/MisrouteRequestMaker/MisrouteRequestMaker.component.js